import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {isContactWithAiPopupShown} from '../../../../../actions/popupActions';
import AudioRecorder from './components/audio-recorder';
import ScanImage from './components/scan-image';
import {useTranslation} from "react-i18next";
import Icon from '../../../icon';

function ContactWithAiPopup ({action, tab}) {

	const [activeTab, setActiveTab] = useState( tab || 'voice');

	const { t } = useTranslation();

	const handleTabChange = (tab) => {
		setActiveTab(tab);
	};

	const contactDetails = useSelector(state => state.contactDetailsReducer.findContactDetails);

	const dispatch = useDispatch();

	return (
		<div
			className="modal-backdrop-custom d-flex align-items-center justify-content-center fade-in"
			onClick={() => dispatch(isContactWithAiPopupShown(null))}
		>
			<div
				className="card shadow-lg p-4 position-relative popup-zoom"
				style={{ width: '500px', maxWidth: '90%', borderRadius: '1rem' }}
				onClick={(e) => e.stopPropagation()}
			>
				<button
					onClick={() => dispatch(isContactWithAiPopupShown(null))}
					className="btn btn-link position-absolute"
					style={{ top: '10px', right: '10px', color: '#6c757d', textDecoration: 'none' }}
				>
					✕
				</button>

				{
					action === 'edit'
					?
						<h5 className="text-center mb-2">{t('editContactWithAiPopupTitle')}</h5>
					:
						<h5 className="text-center mb-2">{t('createContactWithAiPopupTitle')}</h5>
				}

				{
					action === 'edit'
					?
						<p className="text-muted small text-center mb-3">
							{t('editContactWithAiPopupContent')}
						</p>
					:
						<p className="text-muted small text-center mb-3">
							{t('createContactWithAiPopupContent')}
						</p>
				}
				{
					contactDetails && contactDetails.phoneContactEntry.type === 'directory' && <div className="mb-4 p-2 alert alert-warning small">
						<Icon name="warning" className="mr-1"/> {t('contactEditContactDirectoryWarning')}
					</div>
				}
				{
					action !== 'edit' && <ul className="nav nav-tabs nav-justified mb-3 bg-light rounded">
						<li className="nav-item">
							<a
								href="#voice"
								className={`nav-link ${activeTab === 'voice' ? 'active' : ''}`}
								onClick={(e) => { e.preventDefault(); handleTabChange('voice'); }}
							>
								🎙 Voice
							</a>
						</li>
						<li className="nav-item">
							<a
								href="#image"
								className={`nav-link ${activeTab === 'image' ? 'active' : ''}`}
								onClick={(e) => { e.preventDefault(); handleTabChange('image'); }}
							>
								📷 Image
							</a>
						</li>
					</ul>
				}

				<div className="tab-content">

					{activeTab === 'voice' && (
						<div className="tab-pane fade show active">
							<AudioRecorder action={action} onClose={() => dispatch(isContactWithAiPopupShown(null))}/>
						</div>
					)}

					{activeTab === 'image' && action !== 'edit' && (
						<div className="tab-pane fade show active">
							<ScanImage action={action} onClose={() => dispatch(isContactWithAiPopupShown(null))}/>
						</div>
					)}
				</div>
			</div>
		</div>
	)
}

export default ContactWithAiPopup;
